import TabletLayout from "./layouts/TabletLayout";
import config from "./config";
import OculusLayout from "./layouts/OculusLayout";

function DefaultLayout() {
  return config.tablet ? <TabletLayout /> : <OculusLayout />;
}

export default DefaultLayout;
